module.exports = "<div appIconSvg [itemSVG]=\"formatTypeDetails.svg\">\n  <div class=\"cover-svg thumbnail\"  (click)=\"openSize(formatTypeDetails.title, $event)\">\n      <svg:svg viewBox=\"0, 0, 120, 120\"></svg>\n  </div>\n  <br>\n  <label  (click)=\"openSize(formatTypeDetails.title, $event)\">{{formatTypeDetails.title}}</label>\n  <div class=\"arrow\"></div>\n  <div class=\"size-container\">\n  \n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/demo.airtory.com-stage/src/app/icons/icons.component.html
// module id = ../../../../../src/app/icons/icons.component.html
// module chunks = main